class Article {
    constructor({ id, category, title, link, linkName, description, imageUrl, imageType, createdAt, isTrending, likes }) {
        if (!id || !category || !title || !description || !createdAt) {
            throw new Error('Article entity requires id, category, title, description, and createdAt.');
        }

        this.id = id;
        this.category = category;
        this.title = title;
        this.link = link;
        this.linkName = linkName || '';
        this.description = description;
        this.imageUrl = imageUrl;
        this.imageType = imageType || 'banner';
        this.createdAt = createdAt;
        this.isTrending = isTrending || false;
        this.likes = likes || [];
    }
}

export default Article;
